import React, { forwardRef, InputHTMLAttributes } from 'react';

import { cn } from 'src/lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border-border-default bg-layout px-3 py-2 text-sm text-layout-foreground placeholder:text-layout-foreground-secondary focus:border-border-default focus:ring-2 focus:ring-primary-focus focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-layout-foreground-title',
          '[&::-webkit-search-cancel-button]:hidden',
          '[&::-webkit-search-decoration]:hidden',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
